import { IssueSeverity, IssueStatus } from '@/schema/issueReport';

const BADGE_BASE =
  'inline-flex shrink-0 items-center rounded-full border px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em]';

export const SEVERITY_STYLES: Record<IssueSeverity, string> = {
  [IssueSeverity.low]: `${BADGE_BASE} border-white/15 bg-white/5 text-white/60`,
  [IssueSeverity.medium]: `${BADGE_BASE} border-blue-500/40 bg-blue-500/15 text-blue-200`,
  [IssueSeverity.high]: `${BADGE_BASE} border-amber-500/40 bg-amber-500/15 text-amber-200`,
  [IssueSeverity.critical]: `${BADGE_BASE} border-red-500/45 bg-red-500/15 text-red-200`,
};

export const STATUS_STYLES: Record<IssueStatus, string> = {
  [IssueStatus.new]: `${BADGE_BASE} border-primary/40 bg-primary/15 text-primary-200`,
  [IssueStatus.triaged]: `${BADGE_BASE} border-purple-500/40 bg-purple-500/15 text-purple-200`,
  [IssueStatus.inProgress]: `${BADGE_BASE} border-amber-500/40 bg-amber-500/15 text-amber-200`,
  [IssueStatus.resolved]: `${BADGE_BASE} border-emerald-500/40 bg-emerald-500/15 text-emerald-200`,
  [IssueStatus.wontFix]: `${BADGE_BASE} border-white/15 bg-white/5 text-white/55`,
};

export const STATUS_LABELS: Record<IssueStatus, string> = {
  [IssueStatus.new]: 'New',
  [IssueStatus.triaged]: 'Triaged',
  [IssueStatus.inProgress]: 'In progress',
  [IssueStatus.resolved]: 'Resolved',
  [IssueStatus.wontFix]: "Won't fix",
};
